﻿/*
 * Globalize Culture zh-TW
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("zh-TW", "default", {
    name: "zh-TW",
    englishName: "Chinese (Traditional, Taiwan)",
    nativeName: "中文(台灣)",
    language: "zh-CHT",
    numberFormat: {
      NaN: "不是一個數字",
      negativeInfinity: "負無窮大",
      positiveInfinity: "正無窮大",
      percent: {
        pattern: ["-n%", "n%"]
      },
      currency: {
        pattern: ["-$n", "$n"],
        symbol: "NT$"
      }
    },
    calendars: {
      standard: {
        days: {
          names: [
            "星期日",
            "星期一",
            "星期二",
            "星期三",
            "星期四",
            "星期五",
            "星期六"
          ],
          namesAbbr: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
          namesShort: ["日", "一", "二", "三", "四", "五", "六"]
        },
        months: {
          names: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月",
            ""
          ],
          namesAbbr: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月",
            ""
          ]
        },
        AM: ["上午", "上午", "上午"],
        PM: ["下午", "下午", "下午"],
        eras: [{ name: "西元", start: null, offset: 0 }],
        patterns: {
          d: "yyyy/M/d",
          D: "yyyy'年'M'月'd'日'",
          t: "tt hh:mm",
          T: "tt hh:mm:ss",
          f: "yyyy'年'M'月'd'日' tt hh:mm",
          F: "yyyy'年'M'月'd'日' tt hh:mm:ss",
          M: "M'月'd'日'",
          Y: "yyyy'年'M'月'"
        }
      },
      Taiwan: {
        name: "Taiwan",
        days: {
          names: [
            "星期日",
            "星期一",
            "星期二",
            "星期三",
            "星期四",
            "星期五",
            "星期六"
          ],
          namesAbbr: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
          namesShort: ["日", "一", "二", "三", "四", "五", "六"]
        },
        months: {
          names: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月",
            ""
          ],
          namesAbbr: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月",
            ""
          ]
        },
        AM: ["上午", "上午", "上午"],
        PM: ["下午", "下午", "下午"],
        eras: [{ name: "", start: null, offset: 1911 }],
        twoDigitYearMax: 99,
        patterns: {
          d: "yyyy/M/d",
          D: "yyyy'年'M'月'd'日'",
          t: "tt hh:mm",
          T: "tt hh:mm:ss",
          f: "yyyy'年'M'月'd'日' tt hh:mm",
          F: "yyyy'年'M'月'd'日' tt hh:mm:ss",
          M: "M'月'd'日'",
          Y: "yyyy'年'M'月'"
        }
      }
    },
    messages: {
      AdditionalHelp: "其他說明",
      AddNewTab: "新增索引標籤",
      Alerts: "警示",
      ApplyFilter: "套用篩選",
      Approve: "核准",
      Attachments: "附件",
      Back: "返回",
      Basic: "基本",
      Between: "介於",
      Book: "會計帳簿",
      Cancel: "取消",
      Checked: "已核取",
      ClearFilter: "清除篩選",
      Close: "關閉",
      CloseCancelChanges: "關閉並取消變更",
      CloseSaveChanges: "關閉並儲存變更",
      CloseTab: "關閉索引標籤",
      ColumnPersonalization: "直欄個人化",
      Comments: "註解",
      Confirmation: "確認",
      Contains: "包含",
      CreateTab: "建立新的索引標籤",
      Cut: "剪下",
      Delete: "刪除",
      DiscardUndo: "放棄/復原",
      DisplayDropDownList: "顯示下拉式清單",
      Displaying: "顯示: ",
      DocWord: "文件",
      DoesNotContain: "不包含",
      DoesNotEndWith: "結尾並非為",
      DoesNotEqual: "不等於",
      DoesNotStartWith: "開頭並非為",
      Download: "下載",
      Duplicate: "複製",
      Edit: "編輯",
      EitherSelectedorNotSelected: "已選取項或未選取項",
      Email: "電子郵件",
      EndsWith: "結尾為",
      EqualsStr: "等於",
      ExpandCollapse: "展開/折疊",
      ExportFailed: "匯出失敗",
      ExportToExcel: "匯出至 Excel",
      FileInUse: "指定的檔案處於使用中",
      FileInUseDetail: "關閉正在使用該檔案的應用程式或指定其他檔案名稱。",
      Filter: "篩選",
      FilterMenu: "篩選功能表",
      FilterOptions: "篩選選項",
      FilterWithinResults: "在結果內篩選",
      First: "第一個",
      FirstView: "第一個檢視",
      Folder: "資料夾",
      ForgotPassword: "忘記密碼？",
      Forward: "下一頁",
      GetMoreRows: "獲取更多列",
      GreaterThan: "大於",
      GreaterThanOrEquals: "大於或等於",
      GridSettings: "格線設定",
      GroupSelection: "群組選取",
      Help: "說明",
      HideColumn: "說明直欄",
      IsEmpty: "為空",
      IsNotEmpty: "不為空",
      Last: "最後一個",
      LastView: "最後一個檢視",
      LaunchActivate: "啟動/啟用",
      LessThan: "小於",
      LessThanOrEquals: "小於或等於",
      Links: "連結",
      ListTabs: "列出全部索引標籤",
      LoadingItem: "正在載入項目 ",
      Maintenance: "維護",
      Menu: "功能表",
      New: "新增",
      Next: "下一步",
      NextView: "下一個檢視",
      No: "否",
      NotChecked: "未核取",
      Notes: "附註",
      NotSelected: "未選取",
      Of: " / ",
      Ok: "確定",
      Open: "開啟",
      Password: "密碼",
      Paste: "貼上",
      Phone: "電話",
      PleaseWait: "請稍候",
      Previous: "上一步",
      PreviousView: "上一個檢視",
      Print: "列印",
      Queries: "查詢",
      Redo: "重做",
      Refresh: "重新整理",
      Reject: "拒絕",
      RememberMe: "請在電腦上記住我的資訊",
      Reports: "報表",
      Reset: "重設",
      Review: "檢閱",
      RunFilter: "執行篩選",
      RunJob: "執行工作",
      Save: "儲存",
      SaveBeforeClosing: "關閉前儲存",
      SavedFilters: "儲存的篩選",
      SaveSubmit: "儲存/送出",
      ScreenDesign: "螢幕設計",
      Search: "搜尋",
      SelectContents: "選取內容",
      SelectDate: "選取日期",
      SelectDeselect: "全選/取消全選",
      Selected: "已選取: ",
      ServerName: "伺服器名稱",
      Settings: "設定",
      ShowFilterRow: "顯示篩選列",
      SignIn: "登入",
      SortAscending: "遞增排序",
      SortDescending: "遞減排序",
      Spreadsheet: "試算表",
      StartsWith: "開頭為",
      StatusIndicator: "狀態指示器",
      Tasks: "任務",
      Today: "今天",
      Translate: "翻譯",
      UserID: "使用者 ID",
      Utilities: "公用程式",
      Yes: "是",
      Page: "頁",
      Rows: "列",
      ShowingAll: "顯示全部",
      SessionNavigation: "階段作業導覽",
      ListAllMenuItems: "列出全部功能表項目",
      NoRecordsFound: "未找到任何記錄",
      SearchTree: "搜尋樹狀目錄",
      Clear: "清除",
      DrillDown: "向下切入",
      Required: "此欄位為必要欄位。",
      Available: "可用:",
      Add: "新增",
      MoveDown: "下移",
      MoveUp: "上移",
      Remove: "移除",
      LastYear: "去年",
      NextMonth: "下個月",
      NextWeek: "下週",
      NextYear: "明年",
      OneMonthAgo: "一個月前",
      OneWeekAgo: "一週前",
      SixMonthsAgo: "六個月前",
      Time: "時間",
      CannotBeSelected: "此列無法選取。",
      ResetToDefault: "重設為預設版面配置",
      CloseOtherTabs: "關閉其他索引標籤",
      EmailValidation: "請輸入有效的電子郵件地址",
      UrlValidation: "請輸入有效的 URL",
      EndofResults: "結果結尾",
      More: "尚有...",
      RecordsPerPage: "每頁記錄數",
      Maximize: "上限",
      Minimize: "下限",
      CloseAllTabs: "關閉全部索引標籤",
      QuickDates: "快速選取日期",
      Finish: "完成",
      SetTextColor: "設定文字色彩",
      AttachmentRules: "附件規則",
      AutoRefresh: "自動重新整理",
      BarChart: "橫條圖",
      CopyMail: "複製並郵寄",
      CopyUrl: "複製 URL",
      DistributeHorizontally: "水平均分",
      ExpandAll: "全部展開",
      Generate: "產生",
      GenerateScript: "產生指令碼",
      NoAttachments: "無附件",
      PieChart: "圓形圖",
      QuickAccess: "快速存取",
      RestoreUser: "還原使用者",
      SaveConsolidate: "儲存並執行本地合併",
      "Screen Design": "螢幕設計",
      SelectAll: "全選",
      SpellCheck: "拼字檢查",
      SubmitForApproval: "送出以核准",
      Timezone: "時區",
      Loading: "正在載入...",
      NewNode: "新增節點",
      RememberSettings: "記住這些設定",
      Company: "公司",
      Environment: "環境",
      DontHaveAccount: "沒有帳戶?",
      ResetPassword: "重設密碼",
      SignUpNow: "立即註冊",
      SelectMonthYear: "選取月及年"
    }
  });
})(this);
